import React, { useRef , useState} from "react";
import {Box, IconButton, Typography} from "@mui/material";
import VideocamSharpIcon from '@mui/icons-material/VideocamSharp';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DownloadIcon from '@mui/icons-material/Download';
import ExtensionIcon from '@mui/icons-material/Extension';
import ArticleIcon from '@mui/icons-material/Article';
import { Translate } from "@mui/icons-material";
const VideoMessage = ({ url,size, extention }) => {
  const videoRef = useRef(null);
  const [duration, setDuration] = useState(null);

  const handleLoadedMetadata = () => {
    const videoDuration = videoRef.current.duration;
    setDuration(videoDuration); // Set the video duration
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, "0");

    return hours > 0
      ? `${hours}:${minutes.toString().padStart(2, "0")}:${seconds}`
      : `${minutes}:${seconds}`;
  };

  function getDocName(url){
    let fileName = url ? url.split('/').pop() : "";
    return fileName
  }
  return (
    <Box className="chat-media-container attachment-blk"  component={'div'}>
      <Box className="left" component={'div'}>
      <Box className="chat-media-box">
        <video
          ref={videoRef}
          src={url}
          width="100%"
          height="auto"
          muted
          onLoadedMetadata={handleLoadedMetadata}
          style={{ borderRadius: "10px" }}
          loop={false}
        />
          <PlayArrowIcon sx={{color: "#fff", position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}} />

      </Box>
      <Box>
        <Box className="chat-doc-info">{getDocName(url)}</Box>
        {duration && (
        // <Box className="duration" component={'span'}>
        //  <VideocamSharpIcon sx={{fontSize: '1.6rem', top: '-2px', position: 'relative'}} /> {formatTime(duration)}
        // </Box>

<Box>
<Typography component={'span'} className="note-text"><VideocamSharpIcon className="icon" /> {formatTime(duration)}</Typography>
<Typography component={'span'} className="note-text"><ArticleIcon className="icon" /> {size}</Typography>
</Box>

      )}
      </Box>
      </Box>      
    </Box>
  );
};

export default VideoMessage;
